<template>
    <h2 class="gradation">おすすめのファンド</h2>
    <div class="fund_tile rounded-lg elevation-2">
        <router-link :to="{ name: 'fundContent', query: { fund_id: fund_id, title: fund_name } }"
            class="text-decoration-none">
            <div class="fund_tile__thumbnail" :style="thumbnail_style"></div>
        </router-link>
        <div class="px-3 pb-3">
            <router-link :to="{ name: 'fundContent', query: { fund_id: fund_id, title: fund_name } }"
                class="text-decoration-none">
                <div class="fund_tile__subtitle" :style="fundNameStyle">{{ fund_name }}</div>
                <div class="fund_tile__title title">
                    <div :style="subTitleStyle" class="title__name">
                        {{ decodeHtmlEscape(sub_title) }}
                    </div>
                    <div class="title__icon clip-circle--50x50">
                        <div class="title_icon__cover" :style="owner_thumbnail_style">
                            {{ owner_icon_name }}
                        </div>
                    </div>
                </div>
            </router-link>
            <div class="mt-2 d-flex">
                <div v-if="supporter" class="align-self-center">{{ supporter }}人が出資しました</div>
                <div class="ml-auto">
                    <v-btn :loading="isLoading" id="id-watch-icon" :class="{ 'checked': isWatched }"
                        background-color="white" :ripple="false" variant="text" icon="mdi-heart" density="compact"
                        @click="onClickedWatch">
                    </v-btn>
                </div>
            </div>
            <div v-if="user_comment" class="fund_tile__comment comment mt-4">
                <UserComment :user-address="user_address" :user-comment="user_comment"
                    :comment-date="dateFormat(comment_date)" />
            </div>
        </div>
    </div>
</template>

<style scoped>
.fund_tile {
    position: relative;
    overflow: hidden;
}

.fund_tile::after {
    content: "";
    position: absolute;
    width: 300%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0.6;
    background: linear-gradient(110deg, rgba(250, 250, 250, 0) 0%, rgba(250, 250, 250, 0) 40%, rgba(250, 250, 250, 0.5) 50%, rgba(250, 250, 250, 0) 60%, rgba(250, 250, 250, 0) 100%);
    animation: gradient-animation_2 1.2s linear infinite;
    display: v-bind(displayLoading);
}

.fund_tile__thumbnail {
    width: 100%;
    aspect-ratio: 16 / 9;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-color: #cacaca;
}

.fund_tile__subtitle {
    margin-top: 8px;
    font-size: 0.8em;
    color: #666;
}

.fund_tile__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.9em;
    margin-top: 4px;
    gap: 8px;
}

.title__icon {
    background-color: #d3e4ff;
}

.title_icon__cover {
    height: 50px;
    width: 50px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 1.2rem;
    color: #fff;
}

@keyframes gradient-animation_2 {
    0% {
        transform: translateX(-100%);
    }
}

#id-watch-icon {
    color: #cccccc;
}

#id-watch-icon.checked {
    color: #ff0000;
}
</style>

<script>
import axios from "axios"
import UserComment from "../components/UserComment"
// ファイルアセットをimportするとパスロケーションを解決してくれる
import CommentImage from "../assets/images/supporter.png"
import Helper from "../assets/js/helper"
const watchListApi = '/api/watch/item/save'

export default {
    name: 'RecommendFund',
    components: {
        UserComment
    },
    props: {
    },
    data() {
        return {
            comment_thumbnail_style: {
                backgroundImage: `url('${CommentImage}')`,
            },
            owner_thumbnail_style: '',
            condition: '',
            fund_name: '',
            sub_title: '',
            comment_date: '',
            user_comment: '',
            user_address: '',
            fund_id: 0,
            displayLoading: 'block',
            fundNameStyle: {
                backgroundColor: '#cacaca',
                width: '100%',
                height: '25px',
            },
            subTitleStyle: {
                backgroundColor: '#cacaca',
                width: '100%',
                height: '30px',
            },
            owner_icon_name: '',
            supporter: '',
            isWatched: false,
            isLoading: false,
        }
    },
    created: function () {
    },
    // コンポーネントマウントリスナ
    async mounted() {
        this.fetchContent()
    },
    computed: {
    },
    methods: {
        dateFormat(date) {
            return date == null ? '' : Helper.formatDate(date)
        },
        async fetchContent() {

            this.condition = 'requesting';

            const res = await axios.get('/api/fund/recommend').catch(() => {
                this.condition = 'fail';
                return;
            });

            console.log(res);
            this.fund_id = res.data.fund_id;
            this.fund_name = res.data.fund_name;
            this.sub_title = res.data.sub_title;
            this.user_comment = res.data.user_comment;
            this.user_address = res.data.user_address;
            this.comment_date = res.data.comment_date;
            this.supporter = res.data.supporter;
            this.isWatched = res.data.isWatched;
            this.thumbnail_style = { backgroundImage: `url('/data/fund/${res.data.fund_id}/toplist.jpg')` };
            if (res.data.partnerIconName != '') {
                this.owner_icon_name = res.data.partnerIconName;
            } else {
                this.owner_thumbnail_style = { backgroundImage: `url('/data/partner/${res.data.partnerId}/owner.jpg')` };
            }
            this.condition = 'done';

            this.$nextTick(() => {
                this.displayLoading = 'none';
                this.thumbnail_style.opacity = 1;
                this.fundNameStyle.backgroundColor = 'transparent';
                this.fundNameStyle.width = 'auto';
                this.fundNameStyle.height = 'auto';
                this.subTitleStyle.backgroundColor = 'transparent';
                this.subTitleStyle.width = 'auto';
                this.subTitleStyle.height = 'auto';
            })
        },
        decodeHtmlEscape(string) {
            return Helper.decodeHtmlEscape(string)
        },
        onClickedWatch() {
            (async () => {
                try {
                    this.isLoading = true
                    var params = new URLSearchParams();
                    params.append('fund_id', this.fund_id);
                    params.append('mode', this.isWatched ? 'del' : 'add');
                    const response = await axios.post(watchListApi, params)
                    console.log(response)
                    this.isWatched = !this.isWatched

                } catch (error) {
                    console.log(error)
                    alert('ウォッチリストの登録に失敗しました。画面右上のリロードボタンからページを更新後、再度お試しください。')
                } finally {
                    setTimeout(() => {
                        this.isLoading = false                        
                    }, 500);
                }
            })()
        }
    }
}
</script>